import React from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getProperty } from '../ducks/properties.js'

import PropertiesForm from './properties_form.jsx'

const PropertiesEdit = () => {
  const { id } = useParams()
  
  return (
    <ConnectedForm propertyId={id} />
  )
}

const ConnectedForm = connect(
  (state, props) => ({
    property: getProperty(state.properties, props.propertyId)
  })
)(({ property }) => (
  <PropertiesForm property={ property } />
))

export default PropertiesEdit
